module.exports = __webpack_public_path__ + "static/media/천마산.7fe89f17.jpg";